import { Button, Card, CardLayoutType, ColourStateSolid } from '@ukpostbox/frontend-framework';
import { GetArrayIndexByKeyValue } from '@ukpostbox/helpers';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { BatchMailItemEntriesType } from '../../Types/ForwardingBatchTypes';
import { BatchMailItemEntry } from '../Controls/BatchMailItemEntry';

function BatchMailItemEntries(props: BatchMailItemEntriesType) {
	const { currentBatchData } = useForwardingBatchProvider();

	return (
		<>
			{currentBatchData?.splits &&
				currentBatchData?.splits.map((split, index) => (
					<div className='forwarding-batch-split-items-wrapper'>
						<Card
							header={{
								title: `Shipment ${index + 1}`,
								addonEnd: split.externalTrackingUrl && (
									<Button
										title='View Tracking'
										actionLink={{
											title: 'View Tracking',
											url: split.externalTrackingUrl,
											target: '_blank',
										}}
										colour={ColourStateSolid.Primary}
									/>
								),
							}}
							emptyBody
							type={CardLayoutType.Default}
						>
							{split.mailItems.map((splitItem) => {
								if (!splitItem.trackingId) return null;

								const mailItem =
									currentBatchData?.items[
										GetArrayIndexByKeyValue(
											currentBatchData?.items,
											'trackingId',
											splitItem.trackingId,
										)
									];

								if (!mailItem) {
									return (
										<div
											className={`forwarding-batch-item ${props.readOnly ? 'batch-read-only' : ''}`}
										>
											<div className='forwarding-batch-item-entry-title'>
												{splitItem.trackingId}
											</div>
										</div>
									);
								}

								return (
									<BatchMailItemEntry
										key={`fbMailItemSplit_${mailItem.mailUuid}_${splitItem.trackingId}`}
										mailItemIndex={index}
										trackingId={mailItem.trackingId}
										mailUuid={mailItem.mailUuid}
										descriptions={mailItem.descriptions}
										files={mailItem.files}
										mailType={mailItem.mailType}
										readOnly={props.readOnly || props.complete}
										removable={currentBatchData?.items.length > 1}
										removeMailItem={() => props.removeMailItemCallback(mailItem.mailUuid)}
									/>
								);
							})}
						</Card>
					</div>
				))}

			{!currentBatchData?.splits && (
				<div className='forwarding-batch-item-mail-items'>
					{currentBatchData?.items.map((mailItem: any, index) => (
						<BatchMailItemEntry
							key={`fbMailItem_${mailItem.mailUuid}`}
							mailItemIndex={index}
							trackingId={mailItem.trackingId}
							mailUuid={mailItem.mailUuid}
							descriptions={mailItem.descriptions}
							files={mailItem.files}
							mailType={mailItem.mailType}
							readOnly={props.readOnly || props.complete}
							removable={currentBatchData?.items.length > 1}
							removeMailItem={() => props.removeMailItemCallback(mailItem.mailUuid)}
						/>
					))}
				</div>
			)}
		</>
	);
}

export { BatchMailItemEntries };
